import React from "react";
import "./dashboard.css";
import "../index.css";
import BackGroundRectangle from "../components/backgroundRect";
import { Link } from "react-router-dom";

 
export default function SimplCoursesHome() {
  return (
    <React.Fragment>
      <div
        style={{
          width: "450px",
          position: "absolute",
          left: "50%",
          transform: "translateX(-45%)",
          marginTop: "150px",
          paddingBottom: "100px",
          zIndex: 1,
        }}
      >
        <div
          className="bg-white shadow rounded overflow-hidden"
          style={{ marginRight: "35px" }}
        >
          {/* Image */}
          <div style={{ width: "100%", height: "200px", overflow: "hidden" }}>
          <img
            src="https://images.pexels.com/photos/1181675/pexels-photo-1181675.jpeg?auto=compress&cs=tinysrgb&w=600"
            alt="image Course"
            className="img-fluid w-100 h-100"
            style={{ objectFit: "cover" }}
          />
          </div>
  
          {/* Text */}
          <div className="d-flex flex-column justify-content-center p-3">
            <h5 className="fw-bold text-center" style={{ color: "	rgba(56, 114, 168, 1)" }}>
              Brief Video Courses:
            </h5>
            <p className="text-secondary mt-2" style={{ fontSize: "13px", lineHeight: "1.6" }}>
              Welcome to our Brief Video Courses.<br />
              Learn quickly and easily with our short training videos.<br />
              Each video is designed to deliver essential knowledge about SimplControls and its key features.<br />
              Explore the available topics, enhance your skills, and master the system efficiently.
            </p>

            <Link to="/courses2">
            <button
              className="btn btn-primary mt-3" id="explore-btn"
                style={{
                  backgroundColor: "#e4bb34",
                  border: "none",
                  fontSize: "14px",
                  width: "100%",
                }}
                >
              Explore
            </button>
          </Link>

          </div>
        </div>
      </div>
     {/*  <BackGroundRectangle /> */}
    </React.Fragment>
  );
  
}
